import { render } from "./Footer2.vue?vue&type=template&id=7139bb9a&scoped=true"
const script = {}

import "./Footer2.vue?vue&type=style&index=0&id=7139bb9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7139bb9a"]])

export default __exports__